import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconPerson = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={15}
      fill="none"
      viewBox="0 0 14 15"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M1.42461 13.1578C0.708005 10.5604 2.66203 7.99426 5.35642 7.99426H7.70438C10.3988 7.99426 12.3528 10.5604 11.6362 13.1578L11.5985 13.2945C11.4358 13.8841 10.8995 14.2925 10.2879 14.2925H2.77295C2.16134 14.2925 1.62502 13.8841 1.46235 13.2945L1.42461 13.1578Z"
        fill="currentColor"
      />
      <circle cx="6.53187" cy="3.37953" r="3.37953" fill="currentColor" />
    </SvgIcon>
  );
};
